import { render } from "./ShivamAccountGraphics.vue?vue&type=template&id=3c4aad09"
import script from "./ShivamAccountGraphics.vue?vue&type=script&lang=js"
export * from "./ShivamAccountGraphics.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__